import { styled } from '@mui/material/styles'

export const Container = styled('div', {
  name: 'Container',
  slot: 'Root',
  skipSx: true,
})`
  flex-wrap: nowrap;
  max-width: 1116px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;

  @media (max-width: 1000px) {
    flex-wrap: wrap;
    width: 573px;
  }
`
